import Image from "next/image";
import React, { FC } from "react";

import ProfilePicturePlaceholderSrc from "@/features/placeholder/ProfilePicturePlaceholderSrc";

export type AvatarType = {
  src?: string;
  alt?: string;
  walletAccount?: string;
};
export const AvatarImage: FC<AvatarType> = (props) => {
  const { src, alt } = props;

  return (
    <>
      <Image
        alt={alt}
        src={src}
        layout="fill"
        objectFit="cover"
        onMouseDown={(e) => e.preventDefault()}
        priority
      />
    </>
  );
};

export const Avatar: FC<{
  avatar: AvatarType;
  width?: string;
  height?: string;
}> = (props) => {
  const {
    avatar: { src, alt },
    width,
    height,
  } = props;
  const imgAlt = alt ? alt : "user avatar";
  return (
    <div
      className={`relative border-2 border-white inline-block rounded-full ${
        width ? width : "w-16"
      } ${height ? height : "h-16"} overflow-hidden`}
    >
      {src ? (
        <AvatarImage src={src} alt={imgAlt} />
      ) : (
        <AvatarImage src={ProfilePicturePlaceholderSrc} alt={imgAlt} />
      )}
    </div>
  );
};
